const Logger =
  process.env.NODE_ENV === 'development'
    ? {
        error: console.info.bind(console, '%c%s', 'color:red;font-weight:bold;'),
        warn: console.info.bind(console, '%c%s', 'color:orange;font-weight:bold;'),
        info: console.info.bind(console, '%c%s', 'color:#7171e8'),
        log: console.log.bind(console, '%c%s', ''),
        debug: console.debug.bind(console, '%c%s', ''),
      }
    : {
        error: console.info.bind(console, '%c%s', 'color:red;font-weight:bold;'),
        warn: console.info.bind(console, '%c%s', 'color:orange;font-weight:bold;'),
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        info: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        log: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        debug: () => {},
      };

export default Logger;
